import React, { Component } from 'react'
import classNames from 'classnames'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import withStyles from '@material-ui/core/styles/withStyles'
import Colors from '~shared/assets/styles/colors'
import { htmlTextAnchorParser } from '~shared/utils/index'
import FormHelperText from '@material-ui/core/FormHelperText'

class CustomCheckBox extends Component {
  state = {}

  constructor(props) {
    super(props)

    let { text } = props

    if (!text || typeof text !== 'string') {
      this.state = { text }
      return
    }

    const textChildren = htmlTextAnchorParser(text)

    this.state = { text: <React.Fragment>{textChildren}</React.Fragment> }
  }

  static getDerivedStateFromProps(props, state) {
    if (state.checked !== undefined) {
      return {}
    }
    return { checked: props.value }
  }

  handleChange = e => {
    const { onChange } = this.props
    const {
      target: { checked },
    } = e

    this.setState({ checked }, () => {
      onChange && onChange(e)
    })
  }

  render() {
    const { id, classes, invalid, className, required, hideStar } = this.props
    const { checked, text } = this.state

    let errorText
    if (this.props.errorText) {
      errorText = this.props.errorText
    }

    return (
      <React.Fragment>
        <FormControlLabel
          className={classNames(
            classes.checkBoxControl,
            className,
            required ? classes.required : null,
            hideStar ? classes.hideStar : null,
          )}
          control={
            <Checkbox
              id={id}
              checked={checked}
              onChange={this.handleChange}
              color={'secondary'}
              className={`${classes.checkBox} ${invalid ? classes.error : ''}`}
            />
          }
          label={text}
        />
        <FormHelperText
          id={`${id}-error-text`}
          className={classNames(classes.error, classes.errorText)}
        >
          {errorText && invalid ? errorText : ''}
        </FormHelperText>
      </React.Fragment>
    )
  }

  checkValidity = () => !this.props.required || this.state.checked

  getValue = () => this.state.checked
}

const styles = ({ spacing: { unit } }) => ({
  checkBoxControl: {
    alignItems: 'inherit',
    margin: 0,
    paddingRight: unit * 3,
    boxSizing: 'border-box',
    '& span:last-child': {
      marginBottom: unit,
    },
  },
  error: {
    color: Colors.Red,
  },
  errorText: {
    marginTop: 0,
    position: 'relative',
    top: -(unit + 6),
  },
  checkBox: {
    // color: Colors.Grey + '!important',
    marginTop: -unit,
    marginLeft: -unit - 3,
    marginRight: unit * 2,
  },
  required: {
    '&:after': {
      content: '" *"',
    },
  },
  hideStar: {
    '&:after': {
      content: '""',
    },
  },
})

export default withStyles(styles)(CustomCheckBox)
